export const REGEX = {
  NUMBER_KEY_PRESS: /^\d+$/,
  MOBILE_NUMBER: /^[0-9]{6,15}$/,
  LINKEDIN_PROFILE:
    /^(https?:\/\/)?(www\.)?(linkedin\.com\/in\/|linkedin\.com\/pub\/)[a-zA-Z0-9-]+(\/)?(\?[a-zA-Z0-9\-_%=&]*)?$/,
  BROWSER_URl: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
  EMAIL: /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gim,
  PAN_NUMBER: /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
};
